export default [
  {
    path: 'pricing',
    name: 'website.pricing',
    component: () => import('@/views/website/pricing'),
  },
];
